/* hs-eslint ignored failing-rules */
/* eslint-disable react/prop-types */

'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "validCountries", "optionsFilter", "multi", "enableSelectAll"];
import PropTypes from 'prop-types';
import UISelect from 'UIComponents/input/UISelect';
import classNames from 'classnames';
import { getCountryOptions, getOptionsForValidCountries } from '../internal/utils/getCountryOptions';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
const CountrySelect = props => {
  const {
      className,
      validCountries,
      optionsFilter,
      multi,
      enableSelectAll
    } = props,
    passThroughProps = _objectWithoutPropertiesLoose(props, _excluded);
  const options = validCountries ? getOptionsForValidCountries({
    validCountries,
    optionsFilter
  }) : getCountryOptions({
    optionsFilter
  });
  const optionsWithSelectAll = [{
    text: I18n.text('i18nAddon.selectAllOptions'),
    selectAll: true,
    options
  }];
  return /*#__PURE__*/_jsx(UISelect, Object.assign({}, passThroughProps, {
    multi: enableSelectAll || multi,
    anchorType: "button",
    className: classNames('country-select-input', className),
    options: enableSelectAll ? optionsWithSelectAll : options
  }));
};
CountrySelect.propTypes = {
  className: PropTypes.string,
  optionsFilter: PropTypes.func,
  validCountries: PropTypes.array,
  enableSelectAll: PropTypes.bool
};
export default CountrySelect;